<div class="header">
    <h2>{{ 'users.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="users-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'users.fieldset.personal' | translate }}</h2>
        <div class="profile">
            <app-form-avatar
                [control]="form.controls.avatarId"
                [label]="'users.form.avatar' | translate"
                inputId="avatar"
                [accept]="['image/*']"
                testId="users-add-avatar"
            />
            <div class="fields">
                <div class="row">
                    <app-form-input
                        [control]="form.controls.firstName"
                        [label]="'users.form.firstName' | translate"
                        [placeholder]="'users.form.firstName.placeholder' | translate"
                        inputId="firstName"
                        testId="users-add-first-name"
                    />
                    <app-form-input
                        [control]="form.controls.lastName"
                        [label]="'users.form.lastName' | translate"
                        [placeholder]="'users.form.lastName.placeholder' | translate"
                        inputId="lastName"
                        testId="users-add-last-name"
                    />
                </div>
                <app-form-input
                    [control]="form.controls.email"
                    [label]="'users.form.email' | translate"
                    [placeholder]="'users.form.email.placeholder' | translate"
                    type="email"
                    inputId="email"
                    testId="users-add-email"
                />
                <app-form-password
                    [control]="form.controls.password"
                    [label]="'users.form.password' | translate"
                    [placeholder]="'users.form.password.placeholder' | translate"
                    inputId="password"
                    testId="users-add-password"
                />
            </div>
        </div>
    </div>

    <div class="section">
        <h2>{{ 'users.fieldset.roleLocation' | translate }}</h2>
        <div class="row">
            <app-form-select
                [control]="form.controls.role"
                [label]="'users.form.role' | translate"
                [options]="roleOptions"
                inputId="role"
                testId="users-add-role"
            />
            <app-form-select
                [control]="form.controls.country"
                [label]="'users.form.country' | translate"
                [placeholder]="'users.form.country.placeholder' | translate"
                [options]="countryOptions"
                [filter]="true"
                inputId="country"
                testId="users-add-country"
            />
        </div>
        @if (isOrganisationAdmin()) {
            <app-form-select
                [control]="form.controls.organisationId"
                [label]="'users.form.organisation' | translate"
                [placeholder]="'users.form.organisation.placeholder' | translate"
                [options]="organisationOptions()"
                [filter]="true"
                inputId="organisationId"
                testId="users-add-organisation-id"
            />
        } @else {
            <app-form-select
                [control]="form.controls.schoolId"
                [label]="'users.form.school' | translate"
                [placeholder]="'users.form.school.placeholder' | translate"
                [options]="schoolOptions()"
                [filter]="true"
                inputId="schoolId"
                testId="users-add-school-id"
            />
        }
        @if (isSchoolAdmin()) {
            <app-form-input
                [control]="form.controls.contactEmail"
                [label]="'users.form.contactEmail' | translate"
                [placeholder]="'users.form.contactEmail.placeholder' | translate"
                type="email"
                inputId="contactEmail"
                testId="users-add-contact-email"
            />
        }
    </div>

    <div class="section">
        <h2>{{ 'users.fieldset.details' | translate }}</h2>
        <app-form-textarea
            [control]="form.controls.description"
            [label]="'users.form.description' | translate"
            [placeholder]="'users.form.description.placeholder' | translate"
            inputId="description"
            testId="users-add-description"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'users.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="users-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'users.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="users-add-submit"
        (onClick)="onSubmit()"
    />
</div>
